'use client'

import Link from 'next/link'
import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'

const PopoverButton = ({
  options,
  color,
  text,
  removesTextMobile = false,
  icon,
  iconComponent,
  scrollPositionMax,
  scrollPositionCurrent,
  className,
  onChangeAction
}) => (
  <div
    className={`${
      removesTextMobile ? 'w-[100px]' : 'w-[200px]'
    } lg:w-[392px] z-10`}
  >
    <Popover className="relative lg:static">
      {({ open }) => {
        return (
          <div className="grid grid-cols-1 gap-4">
            {!onChangeAction && (
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 -translate-y-1"
                leave="transition ease-in duration-50"
                leaveFrom="opacity-100 -translate-y-1"
                leaveTo="opacity-0 translate-y-1"
                className={`hidden lg:block absolute -mt-[200px] right-0 mr-14 ${
                  scrollPositionCurrent > scrollPositionMax ? 'lg:hidden' : null
                }`}
              >
                <Popover.Panel className="relative z-20">
                  <div
                    className={`grid grid-cols-1 text-blue text-[24px] font-alliance-medium rounded-2xl p-10 shadow-lg ${
                      color ? `bg-${color}` : 'bg-white'
                    }`}
                  >
                    {options.map((item, idx) => {
                      return (
                        <div key={idx}>
                          <Link href={item.link}>{item?.text}</Link>

                          <div
                            className={
                              idx + 1 === options.length
                                ? null
                                : 'border-b border-grey my-6'
                            }
                          />
                        </div>
                      )
                    })}
                  </div>
                </Popover.Panel>
              </Transition>
            )}

            <div className="text-center">
              <Popover.Button className="outline-none">
                <div className="rounded-full">
                  <div
                    className={`${className} flex items-center justify-center rounded-full border border-transparent text-base font-alliance-medium px-6 lg:px-8 py-3 lg:py-5 text-[18px] lg:text-[24px] ${
                      color
                        ? `bg-${color} hover:bg-${color}`
                        : 'bg-white hover:bg-white'
                    }`}
                  >
                    {iconComponent ? (
                      <div className="mr-2 lg:mr-4 w-6 lg:w-9">
                        {iconComponent}
                      </div>
                    ) : (
                      <img
                        src={`/assets/icons/${icon}.svg`}
                        className="mr-2 lg:mr-4 w-6 lg:w-9"
                      />
                    )}

                    <p
                      className={`font-alliance-medium text-[14px] lg:text-[24px] text-blue ${
                        removesTextMobile ? 'lg:block hidden' : null
                      }`}
                    >
                      {text}
                    </p>
                  </div>
                </div>
              </Popover.Button>
            </div>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="opacity-0 -translate-y-1"
              enterTo="opacity-100 translate-y-1"
              leave="transition ease-in duration-50"
              leaveFrom="opacity-100 translate-y-1"
              leaveTo="opacity-0 -translate-y-1"
              className={`hidden lg:block absolute mt-[82px] z-10 ${
                scrollPositionCurrent <= scrollPositionMax ? 'lg:hidden' : null
              }`}
            >
              <Popover.Panel>
                <div
                  className={`grid grid-cols-1 text-blue text-[24px] font-alliance-medium rounded-2xl p-10 shadow-lg ${
                    color ? `bg-${color}` : 'bg-white'
                  }`}
                >
                  {options.map((item, idx) => {
                    return (
                      <div key={idx}>
                        {item?.link ? (
                          <Link href={item.link}>{item?.text}</Link>
                        ) : (
                          <button onClick={onChangeAction} data-id={item.id}>
                            {item?.text}
                          </button>
                        )}

                        <div
                          className={
                            idx + 1 === options.length
                              ? null
                              : 'border-b border-grey my-6'
                          }
                        />
                      </div>
                    )
                  })}
                </div>
              </Popover.Panel>
            </Transition>

            {/* MOBILE */}
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="opacity-0 -translate-y-1"
              enterTo="opacity-100 translate-y-1"
              leave="transition ease-in duration-50"
              leaveFrom="opacity-100 translate-y-1"
              leaveTo="opacity-0 -translate-y-1"
              className="block lg:hidden absolute top-[55px] right-4 z-30"
            >
              <Popover.Panel>
                <div
                  className={`grid grid-cols-1 text-blue text-[14px] font-alliance-medium rounded-2xl w-[250px] p-5 shadow-lg ${
                    color ? `bg-${color}` : 'bg-white'
                  }`}
                >
                  {options.map((item, idx) => {
                    return (
                      <div key={idx}>
                        <div className="flex justify-center">
                          {item?.link ? (
                            <Link href={item.link} className="text-center">
                              {item?.text}
                            </Link>
                          ) : (
                            <button
                              onClick={onChangeAction}
                              data-id={item.id}
                              className="text-center"
                            >
                              {item?.text}
                            </button>
                          )}
                        </div>

                        {idx + 1 !== options.length && (
                          <div className="border-b border-grey my-5" />
                        )}
                      </div>
                    )
                  })}
                </div>
              </Popover.Panel>
            </Transition>
          </div>
        )
      }}
    </Popover>
  </div>
)

export default PopoverButton
